import React, { useEffect, useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { SETTINGS_SECTIONS } from "./schemas";
import { Field, getPath, setPath } from "./Fields";
import { PageTitle } from "./AdminDashboard";
import { useContent } from "../context/ContentContext";

const AdminSettings = () => {
  const { reload } = useContent();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings").then((r) => setForm(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.put("/admin/settings", form); setForm(data); reload(); toast.success("Settings saved"); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  if (!form) return null;
  return (
    <form onSubmit={save} data-testid="admin-settings">
      <PageTitle title="Site Settings" sub="Contact details, logo, statistics, images and Hajj booking info shown across the website.">
        <button type="submit" disabled={busy} className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md bg-jannah-gold text-white text-sm font-bold uppercase tracking-wider hover:bg-jannah-green disabled:opacity-60" data-testid="admin-settings-save">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Save changes
        </button>
      </PageTitle>
      <div className="space-y-6">
        {SETTINGS_SECTIONS.map((sec) => (
          <section key={sec.title} className="rounded-2xl bg-white border border-jannah-sand p-6 md:p-8">
            <h2 className="text-lg font-bold text-jannah-ink mb-5">{sec.title}</h2>
            <div className="grid sm:grid-cols-2 gap-5">
              {sec.fields.map((f) => <Field key={f.key} field={f} value={getPath(form, f.key)} onChange={(v) => setForm(setPath(form, f.key, v))} />)}
            </div>
          </section>
        ))}
      </div>
    </form>
  );
};

export default AdminSettings;
